<header class="content-header-container">
  <h1 class="page-title">Camper Cams <sup class="smText">&#8480;</sup> </h1>
</header>
<p class="pt-3 lato">Select Camera:</p>
<div class="dropdown input-container">
  <mat-form-field class="input">
    <mat-select [formControl]="inputControl" tabindex="0">
      <mat-option
        *ngFor="let option of cameraList"
        [value]="option.display"
        (click)="onSelected(option)"
        (onSelectionChange)="onSelected(option)"
      >
        {{ option.display }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<vg-player>
  <video
    #myMedia
    [vgMedia]="myMedia"
    [vgHls]="selectedUrl"
    type="video/mp4"
    autoPlay="true"
    controls
  ></video>
</vg-player>
<p class="pt-3 lato">
  You're viewing Camper Cams<sup>&#8480;</sup> from this location:
</p>
<div class="mb-3 row no-gutters input-container">
  <div
    class="col-10 d-flex align-items-center input input-location"
    role="listbox"
  >
    <span *ngIf="camperCamsService?.selectedLocation; else elseBlock">
      {{ camperCamsService.selectedLocation.name }}
    </span>
    <ng-template #elseBlock>
      <span>{{ (myProfileService.preferredLocation$ | async)?.name }}</span>
    </ng-template>
  </div>
  <div
    class="icon-container col-2"
    (click)="changeCamperLocation()"
    (keyup.enter)="changeCamperLocation()"
  >
    <span class="link" style="font-size: 0.75rem" tabindex="0">Change</span>
  </div>
</div>
